import { jsx as e } from "react/jsx-runtime";
import { Divider as m } from "@chakra-ui/react";
import { ThemeColorVariable as t } from "../../theme/theme-types.js";
function f({
  borderColor: r = t.OnBackgroundBorder,
  orientation: o = "horizontal",
  ...i
}) {
  return /* @__PURE__ */ e(m, { borderColor: r, orientation: o, ...i });
}
export {
  f as Divider
};
